import React from 'react'

import PageNav from './PageNav'
import slugify from 'slugify'

const Component = ({
  page
}) => {  
  const links = page.headings.map(({value, depth}) => ({
    text: value.split('/', 2)[1] || value,
    href: slugify(value),
    depth
  })).filter(item => item.depth < 4 && item.depth > 1)

  return <PageNav links={links} hide={page.hidePageNav} />
}

export default Component